import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotAllowedPage = () => {
  const navigate = useNavigate();


  const gohome = () => {
    navigate(`/`);
  }

  return (
    <div className="notallowedpage">
      <h1>Access Denied</h1>
      <p className='notallowedpage-text'>You do not have permission to access this page.</p>

      <button onClick={gohome} className="go-home-button">go Home</button>
    </div>
  );
}

export default NotAllowedPage;